import React from 'react';
import styles from './ModalAnuncio.module.css';

const ModalAnuncio = ({ onClose }) => {
  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <img
          src="/Nexa-anuncio.jpg"
          alt="Anuncio"
          className={styles.image}
          width={1100}
          height={619}
          loading="eager"
          fetchpriority="high"
          decoding="async"
        />
        <button className={styles.closeButton} onClick={onClose}>Cerrar</button>
      </div>
    </div>
  );
};

export default ModalAnuncio;
